module.exports = __webpack_public_path__ + "img/BtoB.40ffce80.png";